import {
  abortableFetch,
  EvidenceContext,
  Params,
  TableActionButton,
  TableToolbarButton,
} from '@eas/common-web';
import React, { useContext } from 'react';
import PublishIcon from '@material-ui/icons/Publish';
import { FormImportField } from '../../../components/form-import-field/form-import-field';
import { FormattedMessage } from 'react-intl';

const uploadJson = (
  params: Params,
  selected: string[],
  formData: { file: File | null }
) => {
  if (!formData.file) throw new Error('Nebyl vložen JSON');

  const dto = new FormData();
  dto.append('file', formData.file);

  return abortableFetch('/api/tapis/paragraph/import', {
    method: 'POST',
    body: dto,
  });
};

export const TableToolbarImportButton = () => {
  const { detailRef } = useContext(EvidenceContext);
  // const { showSnackbar } = useContext(SnackbarContext);

  return (
    <TableActionButton
      ButtonComponent={TableToolbarButton}
      promptKey="PARAGRAPHS_IMPORT_JSON"
      apiCall={uploadJson}
      onSuccess={async () => detailRef.current?.refresh()}
      buttonLabel={<PublishIcon />}
      buttonTooltip="Importovat soubor JSON"
      dialogTitle="Import souboru JSON"
      dialogText='Podporovaná struktura souboru JSON je např.:  { "HOMEPAGE": "Vítejte na ...", "RESULTS_PAGE_BANNER": "Výsledky <b>vyhledávání</b> jsou ...", ... }'
      FormFields={() => (
        <FormImportField
          name="file"
          label={
            <FormattedMessage
              id="IP__PARAGRAPHS__TABLE_TOOLBAR_DIALOG__FIELD_LABEL__FILE"
              defaultMessage="Soubor JSON"
            />
          }
          acceptedFormats={['.json', '.txt']}
        />
      )}
      /*   onError={async (err) => {
        if (err.code === 'OBJECT_NOT_IN_STATE_FOR_THIS_OPERATION') {
          showSnackbar(
            `Chyba volání akce: OBJECT_NOT_IN_STATE_FOR_THIS_OPERATION

Zrušit lze pouze rezervace ve stavu "Rozpracovaná" a "Nová plánovaná".`,
            SnackbarVariant.ERROR
          );
        }
      }} */
    />
  );
};
